module.exports = __webpack_public_path__ + "static/donald-trump-707237e3cc96f48fd023e42e6e58b6b3.jpg";